import React from "react";
import "./ContactUsBanner.scss";
export default function ContactUsBanner() {
  return <div className="contact-us-comp-cover" />;
}
